import { useCallback } from 'react';
import { LibraryItemTypeModel, useGetLibraryItemTypesQuery } from '@casops/store/apis/settingsApi';
import { AssetDeviceType } from '@casops/store/apis/registeredAssetsApi';
import { useTranslation } from 'react-i18next';
import { ValueGetterParams } from 'ag-grid-community';

export const useLibraryCompatibleDevicesValueGetter = <TData extends { ty: number }>() => {
  const { t } = useTranslation();

  const { data: libraryItemTypes } = useGetLibraryItemTypesQuery(undefined, {
    refetchOnMountOrArgChange: 120,
  });

  // Return the translated, ordered values (for sorting and searching to work in any language).
  const valueGetter = useCallback(
    ({ data }: ValueGetterParams<TData, string[]>): string[] => {
      if (data && typeof data.ty === 'number' && libraryItemTypes) {
        // Attempt to find a match for the ID.
        const match: LibraryItemTypeModel | undefined = libraryItemTypes.find(
          ({ id }) => id === data.ty,
        );

        if (match) {
          // Return the list of translated, ordered, compatible devices.
          return match.cd
            .map((device: AssetDeviceType) => t(`AssetDeviceType.${device}`))
            .sort((a, b) => a.localeCompare(b));
        }
      }
      return [];
    },
    [t, libraryItemTypes],
  );

  return valueGetter;
};
